import { Popover } from '@headlessui/react'
import { MutableRefObject } from 'react'

import styles from './EarlyKlassTooltip.module.scss'

interface IEarlyKlassTooltip {
  wrapperElementRef: MutableRefObject<HTMLDivElement | null>
}

const EarlyKlassTooltip = ({ wrapperElementRef }: IEarlyKlassTooltip) => {
  return (
    <div ref={wrapperElementRef} className={`${styles.TooltipMotion}`}>
      <Popover className="relative flex w-full justify-center">
        <div className={`${styles.Tooltip}`} />
        <svg
          className={`cursor-default ${styles.TooltipArrow}`}
          width="20"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.26795 0.999997C6.03775 -0.333336 7.96225 -0.333333 8.73205 1L13.0622 8.5C13.832 9.83334 12.8697 11.5 11.3301 11.5H2.66987C1.13027 11.5 0.168022 9.83333 0.937822 8.5L5.26795 0.999997Z"
            fill="#262626"
          />
        </svg>
        <Popover.Panel static className={`absolute z-10 cursor-default ${styles.Tooltip}`}>
          <div className="flex w-[270px] items-center justify-center rounded-full bg-gray-800 py-1 text-white">
            <p className="text-xs">
              지금 사전알림 신청하면{' '}
              <span className="font-semibold text-primary-normal">IT 직무 취업 가이드북</span> 증정
            </p>
          </div>
        </Popover.Panel>
      </Popover>
    </div>
  )
}

export default EarlyKlassTooltip
